import { Button, Flex, FormControl, FormLabel, Icon, Input, Text, useColorModeValue } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { MdGavel } from 'react-icons/md';
import Card from '../../../components/card/Card';
import { toastService } from '../../../services/toast.service';
import { fetchLeilaoConfig, saveLeilaoConfig } from '../../../store/features/leilao/leilao.slice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { RootState } from '../../../store/store';

// Padrões globais do leilão. Cada cliente pode sobrescrever os preços no próprio
// cadastro (tela de Usuários); o que estiver aqui vale para quem não tem override.
export default function LeilaoConfigCard() {
	const dispatch = useAppDispatch();
	const config = useAppSelector((state: RootState) => state.leilao.config);
	const textColor = useColorModeValue('navy.700', 'white');
	const subColor = useColorModeValue('secondaryGray.700', 'secondaryGray.500');

	const [priceToday, setPriceToday] = useState('');
	const [priceOld, setPriceOld] = useState('');
	// Editado como texto separado por vírgula; o estado real é uma lista.
	const [companyIds, setCompanyIds] = useState('');

	useEffect(() => {
		dispatch(fetchLeilaoConfig());
	}, [dispatch]);

	useEffect(() => {
		if (!config) return;
		setPriceToday(String(config.priceToday));
		setPriceOld(String(config.priceOld));
		setCompanyIds((config.companyIds || []).join(', '));
	}, [config]);

	const save = () => {
		const today = Number(priceToday);
		const old = Number(priceOld);
		if (!Number.isFinite(today) || today < 0 || !Number.isFinite(old) || old < 0) {
			toastService.warning('Informe preços válidos (0 ou maior)');
			return;
		}
		const companies = companyIds
			.split(',')
			.map(c => c.trim())
			.filter(Boolean);
		if (!companies.length) {
			toastService.warning('Informe ao menos uma company do Wesend de onde a base é lida');
			return;
		}
		dispatch(saveLeilaoConfig({ priceToday: today, priceOld: old, companyIds: companies }));
	};

	return (
		<Card>
			<Flex align='center' gap='10px' mb='4px'>
				<Icon as={MdGavel} w='22px' h='22px' color='brand.500' />
				<Text fontWeight='800' fontSize='lg' color={textColor}>
					Leilão
				</Text>
			</Flex>
			<Text color={subColor} fontSize='sm' mb='16px'>
				Preços padrão dos leads e a base do Wesend de onde o catálogo é lido. Clientes com preço próprio ignoram
				estes valores.
			</Text>

			<FormControl mb='12px'>
				<FormLabel fontSize='sm'>Preço do lead do dia (R$)</FormLabel>
				<Input
					variant='main'
					inputMode='decimal'
					value={priceToday}
					onChange={e => {
						const v = e.target.value;
						if (v === '' || /^\d*\.?\d*$/.test(v)) setPriceToday(v);
					}}
				/>
			</FormControl>
			<FormControl mb='12px'>
				<FormLabel fontSize='sm'>Preço do lead mais antigo (R$)</FormLabel>
				<Input
					variant='main'
					inputMode='decimal'
					value={priceOld}
					onChange={e => {
						const v = e.target.value;
						if (v === '' || /^\d*\.?\d*$/.test(v)) setPriceOld(v);
					}}
				/>
			</FormControl>
			<FormControl>
				<FormLabel fontSize='sm'>Companies do Wesend</FormLabel>
				<Input
					variant='main'
					placeholder='Ex: fontanella, mix'
					value={companyIds}
					onChange={e => setCompanyIds(e.target.value)}
				/>
				<Text color={subColor} fontSize='xs' mt='4px'>
					Separe por vírgula para vender a base de mais de uma company. O catálogo mostra a união delas, sem
					identificar a origem de cada lead.
				</Text>
			</FormControl>

			<Flex justify='flex-end' mt='12px'>
				<Button variant='brand' onClick={save}>
					Salvar
				</Button>
			</Flex>
		</Card>
	);
}
